(function(){
  /* This file is included more than once on some pages - three times on the
     Trade Portal. It binds nothing and only defines window.StruxaShare, so the
     repeats were harmless until getOwnReferralCode was memoised: each copy got
     its own closure and therefore its own cache, which is why the portal still
     made two /apps/rewards/me requests after that change. One instance only. */
  if (window.__struxaShareLoaded) return;
  window.__struxaShareLoaded = true;

  // Shared "build a link" / "share my cart" helper used across the Custom Strut
  // Builder (All Gas Struts & Accessories page) and the cart drawer / cart page.
  //
  // Encoding: base64url(JSON.stringify([{i,q,p,t,m,c}, ...])) stored in the `items`
  // query param of /pages/shared-build. Keys are single letters and the Shopify CDN
  // image prefix is stripped (both re-expanded on decode) to keep the link as short
  // as possible while still round-tripping title/image/price for a no-network preview.
  // The actual "Add All to Cart" replay only sends {id, quantity, properties} to
  // /cart/add.js, since those are the only fields Shopify's cart API accepts.

  // Every product image on this store is served from the same CDN folder, so we can
  // strip this prefix before encoding and re-add it on decode - saves ~50 chars per item.
  var CDN_PREFIX = 'https://cdn.shopify.com/s/files/1/0776/7477/4628/files/';

  function compressImage(url){
    if(!url) return '';
    if(url.indexOf(CDN_PREFIX) === 0) return '~' + url.slice(CDN_PREFIX.length);
    return url;
  }
  function expandImage(url){
    if(!url) return '';
    if(url.charAt(0) === '~') return CDN_PREFIX + url.slice(1);
    return url;
  }
  // Request a small on-the-fly resized version from Shopify's CDN so thumbnails load
  // fast and crop consistently instead of pulling down the full-resolution original.
  function sizedImage(url, width){
    if(!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + width;
  }

  function b64urlEncode(str){
    var b64 = btoa(unescape(encodeURIComponent(str)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(str){
    var b64 = str.replace(/-/g, '+').replace(/_/g, '/');
    while(b64.length % 4){ b64 += '='; }
    return decodeURIComponent(escape(atob(b64)));
  }

  function buildShareUrl(items){
    var payload = items.map(function(i){
      var out = { i: i.id, q: i.quantity };
      if(i.properties && Object.keys(i.properties).length) out.p = i.properties;
      if(i.title) out.t = i.title;
      var img = compressImage(i.image || '');
      if(img) out.m = img;
      if(typeof i.price === 'number') out.c = i.price;
      return out;
    });
    var encoded = b64urlEncode(JSON.stringify(payload));
    return window.location.origin + '/pages/shared-build?items=' + encoded;
  }

  function decodeItemsFromUrl(){
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('items');
    if(!raw) return null;
    try {
      var parsed = JSON.parse(b64urlDecode(raw));
      if(!Array.isArray(parsed) || !parsed.length) return null;
      // Normalize both the new short-key format and the old long-key format
      // (so links shared before this update still work).
      return parsed.map(function(item){
        return {
          id: item.i !== undefined ? item.i : item.id,
          quantity: item.q !== undefined ? item.q : item.quantity,
          properties: item.p || item.properties || {},
          title: item.t || item.title || '',
          image: expandImage(item.m || item.image || ''),
          price: typeof item.c === 'number' ? item.c : (typeof item.price === 'number' ? item.price : null)
        };
      });
    } catch(e){
      return null;
    }
  }

  function legacyCopy(text){
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch(e){}
    document.body.removeChild(ta);
    return ok ? Promise.resolve() : Promise.reject(new Error('Copy to clipboard failed'));
  }

  function copyToClipboard(text){
    if(!(navigator.clipboard && navigator.clipboard.writeText)){
      return legacyCopy(text);
    }
    // Some browsers/extensions silently never settle the writeText() promise
    // (it neither resolves nor rejects) instead of failing fast - that left
    // share buttons stuck forever waiting on a .then() that never fired. Race
    // it against a short timeout and fall back to the textarea/execCommand
    // method so the caller's promise always settles one way or the other.
    return new Promise(function(resolve, reject){
      var settled = false;
      var timer = setTimeout(function(){
        if(settled) return;
        settled = true;
        legacyCopy(text).then(resolve, reject);
      }, 1200);
      navigator.clipboard.writeText(text).then(function(){
        if(settled) return;
        settled = true;
        clearTimeout(timer);
        resolve();
      }, function(){
        if(settled) return;
        settled = true;
        clearTimeout(timer);
        legacyCopy(text).then(resolve, reject);
      });
    });
  }

  // If the person sharing the cart is signed in and has a referral code
  // (personal Name10 code or trade BusinessName10 code from the /apps/rewards
  // backend), wrap the share link in Shopify's native /discount/CODE?redirect=
  // route so the discount is applied automatically the moment the friend
  // opens the link - before they even see the shared-cart page. Falls back
  // to a plain link (silently) for guests or if the lookup fails.
  /* Memoised on purpose. Several components warm the referral code up front,
     and on the Trade Portal two of them did it within 30ms of each other -
     measured as two concurrent hits taking 1,044ms and 2,073ms, the second
     slower because it was queueing behind the first. One in-flight promise is
     shared by every caller, and the resolved code is reused for 60s so that
     regenerating a code is still picked up shortly after without a reload. */
  var _refCode = null;        // cached promise
  var _refCodeAt = 0;         // when it resolved
  var REF_CODE_TTL = 60000;

  function getOwnReferralCode(){
    /* _refCodeAt is only stamped when the request RESOLVES, so while one is
       still in flight it is 0 and a plain TTL test fails - which is exactly why
       the portal was still making two calls after the first attempt at this.
       In flight (_refCodeAt === 0) means share the promise; resolved means
       honour the TTL. */
    if (_refCode && (_refCodeAt === 0 || (Date.now() - _refCodeAt) < REF_CODE_TTL)) return _refCode;
    _refCode = fetch('/apps/rewards/me', { headers: { 'Accept': 'application/json' } })
      .then(function(res){
        if(!res.ok) return null;
        return res.json();
      })
      .then(function(data){
        _refCodeAt = Date.now();
        return (data && data.code) ? data.code : null;
      })
      .catch(function(){ _refCode = null; return null; });
    return _refCode;
  }

  /* Call after regenerating a code so the next share does not reuse the old one. */
  function forgetOwnReferralCode(){ _refCode = null; _refCodeAt = 0; }

  function withReferralCode(url, code){
    if(!code) return url;
    var origin = window.location.origin;
    var relative = url.indexOf(origin) === 0 ? url.slice(origin.length) : url;
    return origin + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(relative);
  }

  function shareCurrentCart(onDone){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res){ return res.json(); })
      .then(function(cart){
        if(!cart.items || !cart.items.length){
          if(onDone) onDone(new Error('Your cart is empty - add something first.'));
          return;
        }
        var items = cart.items.map(function(item){
          var title = item.product_title || item.title;
          if(item.variant_title && item.variant_title !== 'Default Title'){
            title += ' - ' + item.variant_title;
          }
          return {
            id: item.id,
            quantity: item.quantity,
            properties: item.properties || {},
            title: title,
            image: item.image || '',
            price: item.price
          };
        });
        var url = buildShareUrl(items);
        return getOwnReferralCode().then(function(code){
          var finalUrl = withReferralCode(url, code);
          // Must chain (not fire-and-forget) so a clipboard failure still reaches
          // onDone instead of being silently swallowed as an unhandled rejection - 
          // that was why "Share This Cart" appeared to do nothing on failure.
          return copyToClipboard(finalUrl).then(function(){
            if(onDone) onDone(null, finalUrl, !!code);
          });
        });
      })
      .catch(function(err){
        if(onDone) onDone(err);
      });
  }

  function addAllToCart(items, onDone){
    var reqItems = items.map(function(i){
      var out = { id: i.id, quantity: i.quantity };
      if(i.properties && Object.keys(i.properties).length){ out.properties = i.properties; }
      return out;
    });
    var cartDrawerEl = document.querySelector('cart-drawer');
    var reqBody = { items: reqItems };
    if(cartDrawerEl){
      reqBody.sections = 'cart-drawer,cart-icon-bubble';
      reqBody.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(reqBody)
    }).then(function(res){
      if(!res.ok){ return res.json().then(function(d){ throw new Error(d.description || 'Some of these items could not be added - they may be sold out.'); }); }
      return res.json();
    }).then(function(data){
      if(cartDrawerEl && data && data.sections){
        cartDrawerEl.renderContents(data);
      }
      if(onDone) onDone(null, data);
    }).catch(function(err){
      if(onDone) onDone(err);
    });
  }

  /* Struxa: only "Share This Cart" wrapped the link in the sharer's referral
     code - every per-product and per-build share button called buildShareUrl
     and copyToClipboard directly, so those links carried no code at all. This
     is the one function every share button should call.

     Opt-out: window.SX_REF_SHARE_OPTOUT, set from the customer's preference,
     suppresses the code without changing any call site. */
  function copyShareUrl(url, onDone){
    if (window.SX_REF_SHARE_OPTOUT) {
      return copyToClipboard(url).then(function(){ if(onDone) onDone(null, url, false); return url; });
    }
    return getOwnReferralCode().then(function(code){
      var finalUrl = withReferralCode(url, code);
      return copyToClipboard(finalUrl).then(function(){
        if(onDone) onDone(null, finalUrl, !!code);
        return finalUrl;
      });
    });
  }

  /* withReferralCode is exported because navigator.share() must be called
     synchronously inside a click handler (iOS rejects it after any await), so
     a share button cannot await getOwnReferralCode() first. Callers warm the
     code up front and wrap the URL themselves at click time. */
  window.StruxaShare = {
    buildShareUrl: buildShareUrl,
    decodeItemsFromUrl: decodeItemsFromUrl,
    copyToClipboard: copyToClipboard,
    copyShareUrl: copyShareUrl,
    withReferralCode: withReferralCode,
    shareCurrentCart: shareCurrentCart,
    addAllToCart: addAllToCart,
    sizedImage: sizedImage,
    getOwnReferralCode: getOwnReferralCode,
    forgetOwnReferralCode: forgetOwnReferralCode
  };
})();
